import React, {Component} from 'react'
import {Col, Image, Row} from "react-bootstrap";
import '@brainhubeu/react-carousel/lib/style.css';
import * as PropTypes from "prop-types";
import {Link} from "react-router-dom";
import MainCard from "./MainCard";

/**
 * The component that displays scouting invites.
 */
class NewsAndUpdates extends MainCard {
    /**
     * Render ScoutingInvitesRow components from data object.
     * @returns {React.ReactNode} The ScoutingInvitesRow components.
     */
    renderItemsFromData = () => {
        return this.props.data.map((rowData, index) => (
            <NewsAndUpdatesRow key={index} title={rowData.title} subtitle={rowData.subtitle} description={rowData.description} image={rowData.image} datetime={rowData.datetime} badge={rowData.badge}/>
        ));
    };

    static propTypes = {
        // The text that will appear in the header.
        title: PropTypes.string.isRequired,
        // The text that will appear in the footer.
        footerText: PropTypes.string,
        // The link of see more page.
        footerLink: PropTypes.string,
    };
    static defaultProps = {
        title: "News and Updates",
        footerText: "All Updates",
        footerLink: "#"
    };
}

/**
 * The row component of ScoutingInvites.
 */
class NewsAndUpdatesRow extends Component {
    render = () => {
        const {image, title, subtitle, description, datetime, readMoreText, readMoreLink, badge} = this.props;
        return (
            <Row className="news-and-updates-row">
                <Col sm="auto" className="news-image-container left-side">
                    <Image className="news-image" src={image} alt={title + " image"}/>
                    {badge && <div className="badge"/>}
                </Col>
                <Col className="info-container">
                    <span className="info-1"> {title} </span>
                    <span className="info-2"> {subtitle} </span>
                    <span className="info-3"> {description} </span>
                </Col>
                <Col sm="auto" className="datetime-view-details-container right-side">
                    <div className="datetime-value">{datetime}</div>
                    <div className="view-details">
                        <Link to={readMoreLink}> {readMoreText}</Link>
                    </div>
                </Col>
            </Row>
        );
    };

    static propTypes = {
        // The image of the news.
        image: PropTypes.string.isRequired,
        // The title of the news.
        title: PropTypes.string.isRequired,
        // The subtitle of the news.
        subtitle: PropTypes.string.isRequired,
        // The description of the news.
        description: PropTypes.string.isRequired,
        // The data and time of the news.
        datetime: PropTypes.string.isRequired,
        // The link of news details page.
        detailsLink: PropTypes.string,
    };
    static defaultProps = {
        readMoreLink: "#",
        readMoreText: "Read More"
    };
}

export {NewsAndUpdates, NewsAndUpdatesRow};
